export enum CategoryType {
    Product = 1,
    Service = 2,
    GymMembership=3
}
